import React from 'react'
import ReactDOM from 'react-dom/client'
import { AuthProvider } from 'react-oidc-context'
import { DatadogProvider } from '@datadog/openfeature-browser'
import { init as initFullStory } from '@fullstory/browser'
import { CssBaseline } from '@mui/material'
import { OpenFeature, OpenFeatureProvider } from '@openfeature/react-sdk'
import * as Sentry from '@sentry/react'

import Fallback from './components/error-boundary/fallback'
import App from './App'
import { onSigninCallback, userManager } from './oidc-config'
import AllProviders from './providers'

import './index.css'

const datadogProvider = new DatadogProvider({
  applicationId: 'Central',
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  env: window.location.href.includes('meshifycentral.com') ? 'Production' : window.location.href.includes('meshify.co') ? 'Staging' : 'Development',
})
OpenFeature.setProvider(datadogProvider)

initFullStory({ orgId: 'o-1SRWH4-na1' })

if (!window.location.href.includes('localhost') && !window.location.href.includes('127.0.0.1') && !window.location.href.includes('central-react-pr-')) {
  Sentry.init({
    dsn: 'https://20614d035f4d4e02a3df883f31dcc5c0@o114884.ingest.sentry.io/4505364348010496',
    tracePropagationTargets: ['https://central.meshbot.co', 'https://central.meshify.co', 'https://meshifycentral.com'],
    environment: window.location.href.includes('meshifycentral.com')
      ? 'production'
      : window.location.href.includes('central.meshify.co')
        ? 'staging'
        : 'development',
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.consoleLoggingIntegration({ levels: ['error'] }), // Capture console.error messages
      Sentry.replayIntegration(), // Record and replay user sessions
    ],
  })
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <OpenFeatureProvider>
      <Sentry.ErrorBoundary fallback={Fallback}>
        <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
          <AllProviders>
            <CssBaseline />
            <App />
          </AllProviders>
        </AuthProvider>
      </Sentry.ErrorBoundary>
    </OpenFeatureProvider>
  </React.StrictMode>
)
